module.exports = __webpack_public_path__ + "img/attachment-icon.945cae91.svg";